import React, { useCallback, useState } from "react";
import { Question } from "../utils/types";
import useKeysPress from "../hooks/useKeysPress";
import {
  ANSWER_FEEDBACK_DURATION,
  BOLD_WORDS,
  WHTIE_WORDS,
} from "../utils/constants";
import SussesSound from "../sounds/success.mp3";
import WrongSound from "../sounds/wrong.mp3";
const SuccessAudio = new Audio(SussesSound);
const WrongAudio = new Audio(WrongSound);
export function QuestionView({
  question,
  onQuestionEnd,
}: {
  question: Question;
  onQuestionEnd: Function;
}) {
  const [userAnswer, setUserAnswer] = useState(0);

  const answerAction = useCallback(
    (answerId: number) => {
      if (userAnswer) return;

      if (!question.answers.find((answer) => answer.id === answerId)) return;
      if (answerId === question.correctAnswerId) {
        SuccessAudio.play();
      } else {
        WrongAudio.play();
      }
      setUserAnswer(answerId);
      setTimeout(() => {
        setUserAnswer(0);
        onQuestionEnd();
      }, ANSWER_FEEDBACK_DURATION);
    },
    [question, onQuestionEnd, userAnswer]
  );

  useKeysPress([
    () => {
      answerAction(question.answers[0]?.id);
    },
    () => {
      answerAction(question.answers[1]?.id);
    },
    () => {
      answerAction(question.answers[2]?.id);
    },
  ]);

  const updateQuestionText = useCallback(() => {
    const BoldRegex = new RegExp(`\\b(${BOLD_WORDS.join("|")})\\b`, "gi");
    const WhiteRegex = new RegExp(`\\b(${WHTIE_WORDS.join("|")})\\b`, "gi");
    return question.question
      .replace(BoldRegex, (match) => `<span class="bold">${match}</span>`)
      .replace(WhiteRegex, (match) => `<span class="light">${match}</span>`);
  }, [question]);

  return (
    <>
      <article className="question-container">
        <p dangerouslySetInnerHTML={{ __html: updateQuestionText() }}></p>
      </article>
      <article className="answers-container">
        {question.answers.map((answer) => (
          <div
            key={answer.id}
            className="answer"
            onClick={() => {
              answerAction(answer.id);
            }}
          >
            {!!userAnswer &&
              answer.id === userAnswer &&
              (userAnswer === question.correctAnswerId ? (
                <img src="/assets/true-answer.png" className="feedback" />
              ) : (
                <img src="/assets/false-answer.png" className="feedback" />
              ))}

            {answer.image ? (
              <img src={`/assets/${answer.image}`} alt="answer logo " />
            ) : (
              <p>{answer.answer}</p>
            )}
          </div>
        ))}
      </article>
    </>
  );
}
